import Vue from 'vue'
import App from './App.vue'
import store from './store'
import VueSocketIO from 'vue-socket.io'
import moment from 'moment';
import VueMoment from 'vue-moment';

Vue.use(VueMoment);

import Notifications from 'vue-notification';



Vue.use(Notifications)

Vue.filter('reverse', function(value) {
  // slice to make a copy of array, then reverse the copy
  return value.slice().reverse();
});


Vue.config.productionTip = false


import io from 'socket.io-client';
// const socketInstance = io(process.env.VUE_APP_WEBSOCKET_SERVER, {
//   transports: ['websocket'],
// });

console.log("VUE_APP_WEBSOCKET_SERVER",process.env.VUE_APP_WEBSOCKET_SERVER)

Vue.use(new VueSocketIO({
    debug: false,
    connection: process.env.VUE_APP_WEBSOCKET_SERVER,
    //connection: socketInstance,
    /*vuex: {
        store,
        actionPrefix: 'SOCKET_',
        mutationPrefix: 'SOCKET_'
    },*/
    //options: { path: "/api/v1/" } //Optional options
}))


import AFRAME from 'aframe';

Vue.config.ignoredElements = [
  /a-*/,
];



new Vue({
  store,
  render: h => h(App)
}).$mount('#app')
